import { useMemo } from "react";
import { MergeTagTypeaheadOption } from "../../types/merge-tag-typeahead-option";
import { searchTags } from "../../utils/search-tags";

import type { MergeTagV1 } from "../../../../merge-tag/types";

export const useMergeTagV1LookupService = (
  tags: MergeTagV1[],
  searchText: string | null,
): MergeTagTypeaheadOption[] =>
  useMemo(
    () => searchTags(tags, searchText).map((tag) => new MergeTagTypeaheadOption(tag.id)),
    [searchText, tags],
  );
